import * as modelsGet from "../models/get";
import { getPastors } from "../api/persons";

var pastors: modelsGet.IPerson[];

/**
 * Gibt alle Pfarrer zurück.
 * @param reload Angabe, ob die Status Einträge erneut aus der Datenbank geladen werden sollen.
 */
export async function getPastrosAsync(reload: boolean = false): Promise<modelsGet.IPerson[]>
{
    if (pastors == null || reload)
    {
        pastors = await getPastors();
    }

    return pastors;
}